import React from 'react';
import {
  compensationDeductedLabel,
  formatVnDate,
  sanctionLevelLabel,
  sanctionWindowLabel,
} from '../../utils/brand-sanction';
import { useOrdererSanction } from './orderer-sanction-context';

/** Mục "Lịch sử xử phạt" của chính người đặt đơn: cấp, ngày, lý do, thời hạn, bồi thường đã trừ. */
const OrdererSanctionHistory: React.FC = () => {
  const { history } = useOrdererSanction();
  if (history.length === 0) return <p className="text-sm ui-muted">Chưa có lần xử phạt nào.</p>;
  return (
    <div className="space-y-2">
      {history.map((s) => (
        <div key={s.id} className="rounded-lg border ui-divider p-3" data-testid="sanction-history-item">
          <div className="flex flex-wrap items-center justify-between gap-2">
            <span className="rounded-full bg-rose-50 px-2.5 py-0.5 text-[12px] font-semibold text-rose-700 dark:bg-rose-900/30 dark:text-rose-300">
              {sanctionLevelLabel(s.level)}
            </span>
            <span className="text-xs ui-muted">Ngày {formatVnDate(s.createdAt)}</span>
          </div>
          <p className="mt-2 whitespace-pre-wrap text-sm ui-text">{s.reason}</p>
          <div className="mt-2 flex flex-wrap gap-x-4 gap-y-0.5 text-xs ui-muted">
            <span>Thời hạn: {sanctionWindowLabel(s)}</span>
            <span>Bồi thường đã trừ: {compensationDeductedLabel(s)}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default OrdererSanctionHistory;
